import {mapToTypeFromString} from '../../../common/common';
export enum UserStatusType {
  ANONYMOUS = 'ANONYMOUS',
  IMPLICIT = 'IMPLICIT',
  EXPLICIT = 'EXPLICIT'
}

export namespace UserStatusType {
  export const fromString = (input: string): UserStatusType => {
    return mapToTypeFromString<UserStatusType>(UserStatusType, input);
  }
  export const isAnonymous = (input: UserStatusType) => {
    return input && input === UserStatusType.ANONYMOUS;
  }
  export const isImplicit = (input: UserStatusType) => {
    return input && input === UserStatusType.IMPLICIT;
  }
  export const isExplicit = (input: UserStatusType) => {
    return input && input === UserStatusType.EXPLICIT;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/user-status-type.model.ts